import { JastBuilder } from '@atlaskit/jql-ast';

// Heuristic — returns true when the query parses as JQL with a where or order-by clause.
export const isTypedJql = (query: string): boolean => {
	const trimmed = query?.trim();
	if (!trimmed) {
		return false;
	}

	try {
		const ast = new JastBuilder().build(trimmed);
		if (ast.errors.length > 0 || !ast.query) {
			return false;
		}
		return Boolean(ast.query.where) || Boolean(ast.query.orderBy);
	} catch {
		return false;
	}
};
